const CONSTANTS = {
  // API_URL: 'http://localhost:9000'
  API_URL: 'https://test.atcpl.ltd'
};

export default CONSTANTS;
